// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CategoryTabs_wrap__1Dqc_","flex":"CategoryTabs_flex__Ap_hs","button":"CategoryTabs_button__tpFvP","active":"CategoryTabs_active__cXUsF"};